import React from 'react'
import ProductPreviewPart from '../../shared/previews/ProductPreviewPart'

export default function ProductPreview({ project }) {
  return (
    <ProductPreviewPart project={project} projectGalleryImages={project.project_gallery_images} />
  )
}